module.exports = __webpack_public_path__ + "img/area.5adfd393.svg";